// extracted by mini-css-extract-plugin
export default {"frame":"subscription-overview_frame__6wM9B"};